import { useMemo } from "react";

import { useClientsProjects } from "~/modules/project/api/project/projectQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { createInputOptionData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useClientsProjectSelectOptions = (clientId: string): FormInputOption[] => {
	const { data: projects } = useClientsProjects(clientId);
	return useMemo(() => {
		if (projects) {
			return [...projects
				.sort(byObjectProperty("title"))
				.map(project => createInputOptionData(`${project.title} (${project.projectNumber})`, project.id))];
		}
		return [];
	}, [projects]);
};

export default useClientsProjectSelectOptions;

